import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Analytics } from '@vercel/analytics/react';

/* ResizeObserver can fire during layout; Monaco/grid toggles may briefly trigger a benign
   browser warning. Defer layout in ProblemDetail where possible; filter known noise here. */
function isBenignResizeObserverMessage(message) {
  if (!message) return false;
  const s = String(message);
  return (
    s.includes('ResizeObserver loop completed with undelivered notifications') ||
    s.includes('ResizeObserver loop limit exceeded')
  );
}

function swallowResizeObserverErrorEvent(event) {
  const msg =
    event?.message ||
    (event?.error && event.error.message) ||
    '';
  if (!isBenignResizeObserverMessage(msg)) return;
  event.preventDefault?.();
  event.stopImmediatePropagation?.();
}

window.addEventListener('error', swallowResizeObserverErrorEvent, true);
window.addEventListener('error', swallowResizeObserverErrorEvent, false);

const prevWindowOnError = window.onerror;
window.onerror = function resizeObserverSafeOnError(message, source, lineno, colno, error) {
  const msg = error?.message || String(message || '');
  if (isBenignResizeObserverMessage(msg)) {
    return true;
  }
  if (typeof prevWindowOnError === 'function') {
    return prevWindowOnError.call(window, message, source, lineno, colno, error);
  }
  return false;
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
    <Analytics />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: `reportWebVitals(console.log)`)
// to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
